import React, { useState } from 'react';
import TodoForm from './TodoForm';
import { RiCloseCircleLine } from 'react-icons/ri';
import { TiEdit } from 'react-icons/ti';
import { BiTime } from 'react-icons/bi';

function TodoList({ todos, completeTodo, removeTodo, updateTodo }) {
  const [edit, setEdit] = useState({
    id: null,
    value: '',
    priority: '',
    time: ''
  });

  const submitUpdate = value => {
    updateTodo(edit.id, value);
    setEdit({
      id: null,
      value: '',
      priority: '',
      time: ''
    });
  };

  const formatTime = (time) => {
    if (!time) return '';
    return new Date('2000/01/01 ' + time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const formatDuration = (minutes) => {
    if (minutes >= 60) {
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;
      return `${hours}h${mins ? ` ${mins}m` : ''}`;
    }
    return `${minutes}m`;
  };

  if (edit.id) {
    return <TodoForm edit={edit} onSubmit={submitUpdate} />;
  }

  return (
    <div className="todo-list">
      {todos.map((todo, index) => (
        <div 
          className={`todo-row ${todo.priority} ${todo.isComplete ? 'complete' : ''}`}
          key={index}
        >
          <div className="task-details" onClick={() => completeTodo(todo.id)}>
            <div className="todo-text">
              {todo.text}
              <span className="priority-badge">{todo.priority}</span>
            </div>
            {todo.time && (
              <div className="time-info">
                <span className="time-badge">{todo.time}</span>
              </div>
            )}
          </div>
          <div className="icons">
            <RiCloseCircleLine
              onClick={() => removeTodo(todo.id)}
              className="delete-icon"
            />
            <TiEdit
              onClick={() => setEdit({
                id: todo.id,
                value: todo.text,
                priority: todo.priority,
                time: todo.time
              })}
              className="edit-icon"
            />
          </div>
        </div>
      ))}
    </div>
  );
}

export default TodoList; 